import type { EvolutionProposal } from "../../lib/api";
import { Badge } from "../ui";

export function EvolutionProposalCard({ proposal }: { proposal: EvolutionProposal }) {
  return (
    <article className="rounded-md border border-border bg-surface p-4">
      <div className="flex items-center justify-between gap-3">
        <h3 className="text-[14px] font-medium text-ink">{proposal.title}</h3>
        <Badge tone={proposal.compatibility === "breaking" ? "danger" : "neutral"} size="xs">
          {proposal.compatibility}
        </Badge>
      </div>
      <p className="mt-2 text-[13px] leading-relaxed text-ink-dim">{proposal.summary}</p>
      {proposal.suggested_web_surfaces.length > 0 && (
        <div className="mt-3 text-[12px] text-ink-faint">{proposal.suggested_web_surfaces.join(", ")}</div>
      )}
    </article>
  );
}
